// ─── PLAYERS MASCULINO ────────────────────────────────────────────────────────
export const INITIAL_PLAYERS = [];

// ─── PLAYERS FEMININO ─────────────────────────────────────────────────────────
// Adicione os nomes das jogadoras aqui conforme forem cadastradas
export const INITIAL_PLAYERS_F = [];

// ─── PLAYERS LEGENDS (60+) ────────────────────────────────────────────────────
// Adicione os nomes dos jogadores Legends aqui conforme forem cadastrados
export const INITIAL_PLAYERS_S = [];

// ─── GENDER CONTEXT ───────────────────────────────────────────────────────────
// Divisões do ranking: M = Masculino, F = Feminino, S = Legends (60+, sênior).
// Para criar uma nova divisão: adicionar a chave aqui + as 5 tabelas no Supabase.
export const GENDER = {
  M: "M",
  F: "F",
  S: "S",
  keys: ["M", "F", "S"],
  label: { M: "Masculino", F: "Feminino", S: "Legends" },
  shortLabel: { M: "Masc", F: "Fem", S: "Legends" },
  emoji: { M: "♂", F: "♀", S: "★" },
  // Tabelas no Supabase
  tables: {
    M: { players: "players",    challenges: "challenges",    results: "results",    positionHistory: "position_history",    inactivityHistory: "inactivity_history"    },
    F: { players: "players_f",  challenges: "challenges_f",  results: "results_f",  positionHistory: "position_history_f",  inactivityHistory: "inactivity_history_f"  },
    S: { players: "players_60", challenges: "challenges_60", results: "results_60", positionHistory: "position_history_60", inactivityHistory: "inactivity_history_60" },
  },
};

// ─── FERIADOS NACIONAIS FIXOS ─────────────────────────────────────────────────
// Feriados de data fixa — aplicam regras de domingo nas quadras.
// Feriados móveis (Carnaval, Sexta Santa, Corpus Christi) devem ser
// cadastrados manualmente pelo admin a cada ano.
export const FIXED_HOLIDAYS = [
  { month: 1,  day: 1,  name: "Confraternização Universal" },
  { month: 4,  day: 21, name: "Tiradentes" },
  { month: 5,  day: 1,  name: "Dia do Trabalho" },
  { month: 9,  day: 7,  name: "Independência do Brasil" },
  { month: 10, day: 12, name: "Nossa Senhora Aparecida" },
  { month: 11, day: 2,  name: "Finados" },
  { month: 11, day: 15, name: "Proclamação da República" },
  { month: 12, day: 25, name: "Natal" },
];

// ─── TEMPORADAS ───────────────────────────────────────────────────────────────
// CURRENT_SEASON: temporada em andamento. Resultados e períodos de inatividade
// novos são gravados com este ano, e as telas mostram só esta temporada.
// PAST_SEASONS: temporadas arquivadas, consultáveis na aba "Temporadas".
// Na próxima virada: mover o ano atual para PAST_SEASONS e atualizar CURRENT_SEASON.
export const CURRENT_SEASON = 2027;
export const PAST_SEASONS = [2026];

// ─── APP CONFIG ───────────────────────────────────────────────────────────────
export const ADMIN_PASS = "admin2026";
export const CONFIRM_DEADLINE_DAYS = 3;

export const RULES_SECTIONS = [
  { icon: "📋", title: "Regulamento em Breve", text: "O regulamento será publicado em breve." },
];

// ─── PYRAMID BUILDER ──────────────────────────────────────────────────────────
export function buildPyramidRows(totalPlayers) {
  const rows = [];
  let count = 0, rowSize = 6;
  while (count < totalPlayers) {
    const size = Math.min(rowSize, totalPlayers - count);
    rows.push([count + 1, count + size]);
    count += size;
    if (rows.length >= 2) rowSize += 2;
  }
  return rows;
}

// ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
export const C = {
  bg:      "#f0f2f5",
  card:    "#ffffff",
  cardAlt: "#f7f8fa",
  border:  "#e0e4eb",
  primary: "#005095",   // azul — masculino
  female:  "#a0006e",   // rosa escuro — feminino
  legends: "#9a6b00",   // dourado escuro — Legends (60+)
  accent:  "#00a882",
  text:    "#1a2333",
  muted:   "#556070",
  success: "#00a05a",
  warning: "#e08a00",
  info:    "#2a7fd4",
  white:   "#ffffff",
};

export const font     = "'Barlow', sans-serif";
export const fontCond = "'DM Sans', sans-serif";

// Cor de destaque de cada divisão (M azul, F rosa, S dourado)
export function genderColor(g) {
  return g === "F" ? C.female : g === "S" ? C.legends : C.primary;
}

// ─── STYLES ───────────────────────────────────────────────────────────────────
export const S = {
  app:      { fontFamily: font, minHeight: "100vh", background: C.bg, color: C.text },

  header:   (isMobile) => ({
    background: C.card, borderBottom: "1px solid " + C.border,
    boxShadow: "0 1px 8px rgba(0,0,0,.06)",
    padding: isMobile ? "0 16px" : "0 24px",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    height: isMobile ? 52 : 56,
    position: "sticky", top: 0, zIndex: 200, overflow: "visible",
  }),

  logo:     {
    fontFamily: fontCond, fontSize: 20, fontWeight: 900, letterSpacing: 2,
    color: C.text, display: "flex", alignItems: "center", gap: 10,
    flexShrink: 0, overflow: "visible",
  },

  nav:      { display: "flex", gap: 2, flexWrap: "wrap", flex: 1, justifyContent: "center" },

  navBtn:   (a, h) => ({
    background: a ? C.primary : h ? "#f0f4f8" : "transparent",
    color: a ? "#fff" : h ? C.text : C.muted,
    border: "none", borderRadius: 6, padding: "7px 14px", cursor: "pointer",
    fontWeight: 600, fontSize: 13, fontFamily: font, letterSpacing: .3,
    transition: "background .15s, color .15s", minHeight: 36,
  }),

  // Seletor de gênero M / F — centralizado no header
  genderToggle: { display: "flex", gap: 0, alignItems: "center", border: "1px solid " + C.border, borderRadius: 8, overflow: "hidden" },

  genderBtn: (active, genderKey) => ({
    background: active ? genderColor(genderKey) : C.card,
    color: active ? "#fff" : C.muted,
    border: "none",
    borderRadius: 0, padding: "7px 20px", cursor: "pointer",
    fontWeight: 700, fontSize: 13, fontFamily: font, letterSpacing: .3,
    transition: "background .15s, color .15s",
    minHeight: 36,
  }),

  logoutBtn: {
    background: "transparent", color: C.muted,
    border: "1px solid " + C.border, borderRadius: 6,
    padding: "6px 14px", cursor: "pointer", fontSize: 12,
    fontFamily: font, minHeight: 36, minWidth: 44,
  },

  body:     (isMobile) => ({
    maxWidth: 1300, margin: "0 auto",
    padding: isMobile ? "16px 12px 24px" : "24px 16px",
  }),

  card:       { background: C.card, borderRadius: 14, padding: 20, marginBottom: 12, border: "1px solid " + C.border },
  cardMobile: { background: C.card, borderRadius: 12, padding: 16, marginBottom: 10, border: "1px solid " + C.border },

  title:    {
    fontFamily: fontCond, fontSize: 18, fontWeight: 800, marginBottom: 14,
    color: C.text, letterSpacing: .5, display: "flex", alignItems: "center", gap: 8,
  },

  input:    {
    background: "#f7f9fc", border: "1px solid " + C.border, borderRadius: 8,
    padding: "12px 14px", fontSize: 16, width: "100%", boxSizing: "border-box",
    marginBottom: 10, color: C.text, fontFamily: font, outline: "none", minHeight: 44,
  },

  btn:      (c, outline) => ({
    background: outline ? "transparent" : (c || C.primary),
    color: outline ? (c || C.primary) : "#fff",
    border: outline ? "1px solid " + (c || C.primary) : "none",
    borderRadius: 8, padding: "12px 20px", cursor: "pointer",
    fontWeight: 700, fontSize: 14, fontFamily: font,
    minHeight: 44, minWidth: 44,
    display: "inline-flex", alignItems: "center", justifyContent: "center",
  }),

  badge:    (c) => ({
    background: c + "22", color: c, borderRadius: 20, padding: "3px 10px",
    fontSize: 11, fontWeight: 700, letterSpacing: .5,
    border: "1px solid " + c + "44", display: "inline-block",
  }),

  row:      { display: "flex", alignItems: "center", gap: 10, marginBottom: 10 },
  table:    { width: "100%", borderCollapse: "collapse" },
  th:       {
    textAlign: "left", padding: "10px 12px", borderBottom: "1px solid " + C.border,
    fontSize: 11, color: C.muted, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase",
  },
  td:       { padding: "12px 12px", borderBottom: "1px solid " + C.border + "88", fontSize: 13, color: C.text },

  select:   {
    background: "#f7f9fc", border: "1px solid " + C.border, borderRadius: 8,
    padding: "12px 14px", fontSize: 16, marginBottom: 10,
    width: "100%", color: C.text, fontFamily: font, minHeight: 44,
  },

  msg:      (t) => ({
    position: "fixed", bottom: 80, left: "50%", transform: "translateX(-50%)",
    background: t === "error" ? C.primary : t === "info" ? C.info : C.accent,
    color: "#fff", padding: "12px 24px", borderRadius: 30,
    fontWeight: 700, fontSize: 14, zIndex: 9999,
    boxShadow: "0 8px 32px rgba(0,0,0,.4)", fontFamily: font,
    whiteSpace: "nowrap", maxWidth: "90vw",
  }),

  modal:    {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,.7)", zIndex: 1000,
    display: "flex", alignItems: "flex-end", justifyContent: "center",
    padding: 0, backdropFilter: "blur(4px)",
  },

  modalBox: (isMobile) => ({
    background: C.card, borderRadius: 18,
    padding: isMobile ? "24px 20px 32px" : 32,
    width: "100%", maxWidth: 460,
    boxShadow: "0 8px 40px rgba(0,0,0,.3)",
    border: "1px solid " + C.border,
    maxHeight: "90vh", overflowY: "auto",
  }),

  label:    {
    fontSize: 12, fontWeight: 700, letterSpacing: 1.5,
    color: C.muted, textTransform: "uppercase", marginBottom: 6, display: "block",
  },

  adminTab: (a) => ({
    background: "transparent", color: a ? C.primary : C.muted,
    border: "none", borderBottom: a ? "2px solid " + C.primary : "2px solid transparent",
    padding: "10px 12px", cursor: "pointer",
    fontWeight: 700, fontSize: 13, fontFamily: font, minHeight: 44,
  }),

  danger:   {
    background: "#fde8ec", border: "1px solid " + C.primary + "55",
    borderRadius: 10, padding: "14px 16px", marginBottom: 10,
  },
};
